<template>
  <div>
    <div class="row">
      <div class="col-sm-6 col-md-6">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Loads Scheduled</h5>
          </div>
          <div class="ibox-content ibox-content-padding-xs-slim">
            <div class="row">
              <div class="col-md-6">
                <h1 class="no-margins">{{ loadsScheduledCounts.loads_today }}</h1>
                <div class="stat-percent font-bold" :class="[scheduledDayIncreaseIsNegative ? 'text-danger' : 'text-info']">{{ scheduledDayIncrease }}%
                  <i v-if="loadsScheduledCounts.day_increase >= 0" class="fa fa-level-up"></i>
                  <i v-else class="fa fa-level-down"></i>
                </div>
                <small>Today</small>
              </div>
              <div class="col-md-6">
                <h1 class="no-margins">{{ loadsScheduledCounts.loads_this_month }}</h1>
                <div class="stat-percent font-bold" :class="[scheduledMonthIncreaseIsNegative ? 'text-danger' : 'text-info']">
                  {{ scheduledMonthIncrease }}%
                  <i v-if="loadsScheduledCounts.month_increase >= 0" class="fa fa-level-up"></i>
                  <i v-else class="fa fa-level-down"></i>
                </div>
                <small>This Month</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Commission</h5>
          </div>
          <div class="ibox-content ibox-content-padding-xs-slim">
            <div class="row">
              <div class="col-md-6">
                <h1 class="no-margins">{{ commissionTodayFormatted }}</h1>
                <div class="stat-percent font-bold" :class="[commissionDayIncreaseIsNegative ? 'text-danger' : 'text-info']">{{ commissionDayIncrease }}%
                  <i v-if="commissionData.day_increase >= 0" class="fa fa-level-up"></i>
                  <i v-else class="fa fa-level-down"></i>
                </div>
                <small>Today</small>
              </div>
              <div class="col-md-6">
                <h1 class="no-margins">{{ commissionMonthFormatted }}</h1>
                <div class="stat-percent font-bold" :class="[commissionMonthIncreaseIsNegative ? 'text-danger' : 'text-info']">{{ commissionMonthIncrease }}%
                  <i v-if="commissionData.month_increase >= 0" class="fa fa-level-up"></i>
                  <i v-else class="fa fa-level-down"></i>
                </div>
                <small>This Month</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Loads Per Day</h5>
          </div>
          <div class="ibox-content no-padding-top">
            <div>
              <loads-per-day-graph></loads-per-day-graph>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$user.isAdminOrCoordinator" class="col-md-6">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Commission Per Day</h5>
          </div>
          <div class="ibox-content no-padding-top">
            <div>
              <commission-per-day-graph></commission-per-day-graph>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="col-md-6">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Scheduled Loads</h5>
          </div>
          <div class="ibox-content no-padding-top">
            <div>
              <scheduled-loads-graph></scheduled-loads-graph>
            </div>
          </div>
        </div>
      </div>
      -->
    </div>

    <div class="ibox">
      <div class="ibox-title">
        <h5>User Growth Per Month</h5>
      </div>
      <div class="ibox-content no-padding-top">
        <div>
          <user-growth-graph></user-growth-graph>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import accounting from 'accounting'
  import LoadsPerDayGraph from './LoadsPerDayGraph'
  import CommissionPerDayGraph from './CommissionPerDayGraph'
  import ScheduledLoadsGraph from './ScheduledLoadsGraph'
  import UserGrowthGraph from './UserGrowthGraph'

  export default {
    components: {
      LoadsPerDayGraph,
      CommissionPerDayGraph,
      ScheduledLoadsGraph,
      UserGrowthGraph
    },

    data () {
      return {
        loadsScheduledCounts: [],
        commissionData: []
      }
    },

    created () {
      this.getLoadsScheduledCount()
        .then(response => {
          this.loadsScheduledCounts = response.data
        })

      this.getCommissionData()
        .then(response => {
          this.commissionData = response.data
        })
    },

    computed: {
      scheduledDayIncreaseIsNegative () {
        return this.loadsScheduledCounts.day_increase < 0
      },

      scheduledDayIncrease () {
        if (this.loadsScheduledCounts.day_increase < 0) {
          return this.loadsScheduledCounts.day_increase * -1
        }
        return this.loadsScheduledCounts.day_increase
      },

      scheduledMonthIncreaseIsNegative () {
        return this.loadsScheduledCounts.month_increase < 0
      },

      scheduledMonthIncrease () {
        if (this.loadsScheduledCounts.month_increase < 0) {
          return this.loadsScheduledCounts.month_increase * -1
        }
        return this.loadsScheduledCounts.month_increase
      },

      commissionDayIncreaseIsNegative () {
        return this.commissionData.day_increase < 0
      },

      commissionDayIncrease () {
        if (this.commissionData.day_increase < 0) {
          return this.commissionData.day_increase * -1
        }
        return this.commissionData.day_increase
      },

      commissionMonthIncreaseIsNegative () {
        return this.commissionData.month_increase < 0
      },

      commissionMonthIncrease () {
        if (this.commissionData.month_increase < 0) {
          return this.commissionData.month_increase * -1
        }
        return this.commissionData.month_increase
      },

      commissionTodayFormatted () {
        return accounting.formatMoney(this.commissionData.commission_today)
      },

      commissionMonthFormatted () {
        return accounting.formatMoney(this.commissionData.commission_this_month)
      }
    },

    methods: mapActions('dashboard', ['getLoadsScheduledCount', 'getCommissionData'])
  }
</script>



// WEBPACK FOOTER //
// Graphs.vue?01def7bf